import { useStoreState } from 'providers/StoreStateContext';
import { PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFetchRefreshToken } from 'services/auth';

type ProtectedRouteProps = PropsWithChildren;

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const {
    token,
    refreshToken: currentRefreshToken,
    setToken,
    setRefreshToken,
    tokenData,
  } = useStoreState();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { mutateAsync } = useFetchRefreshToken();
  const { t } = useTranslation();

  const refreshTokens = async (exp: number) => {
    const tokenExp = (exp - 90) * 1000;
    if (tokenExp < Date.now()) {
      console.log('Token expired, refreshing...');
      if (!currentRefreshToken) return;
      await mutateAsync(
        { token: currentRefreshToken },
        {
          onSuccess: data => {
            if (data.token && data.refreshToken) {
              setToken(data.token);
              setRefreshToken(data.refreshToken);
            }
          },
        }
      );
    }
  };

  useEffect(() => {
    if (!tokenData) {
      navigate('/login', { replace: true });
    }

    if (tokenData) {
      const timeout = (tokenData.exp - 60) * 1000 - Date.now();

      if (timeout > 0) {
        console.log(`Token expires in: ${Math.round(timeout / 60000)} min`);
      }

      const timerId = setTimeout(() => refreshTokens(tokenData.exp), timeout);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [currentRefreshToken, token]);



  return <>{children}</>;
}
